import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../context/AuthContext';
import SecurityHeaders from '../../data/SecurityHeaders';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Dropdown } from 'react-bootstrap';
import { Avatar } from '@mui/material';
import dateFormat from 'dateformat';
import Chip from '@mui/material/Chip';
const CompanyBounties = ({ company }) => {

  // const {user} = useContext(AuthContext);
  const [submissions, setSubmissions] = useState([]);
  const params = useParams();

  const getSubmissions = async () => {
    const data = new FormData();
    data.append('bounty_id', params.id);
    try {


      const response = await axios.post(`https://skillsuprise.com/bounty-wise-submissions.php`, data, SecurityHeaders);
      if (response.data.status === 'success') {
        setSubmissions(response.data.data);


      } else {
        console.error(response.data.message);

      }
    } catch (error) {
      console.log(error.message);
    }
  }

  useEffect(() => {
    getSubmissions();
  }, []);

  const updateSubmission = async (item) => {
    try {


      const data = new FormData();
      data.append('submission_id', item.id);
      data.append('status', item.status);


      const response = await axios.post(`https://internalapi.skillsuprise.com/update-bounty-submission.php`, data, SecurityHeaders);

      if (response.data.status === 'success') {
        getSubmissions()
      } else {
        // Dispatch an error action

        console.error(response.data.message);
      }
    } catch (error) {
      // Dispatch an error action

      console.error(error);
    }
  };

  return (
    <div className=" py-5">
      <div className='container '>
        <div className='row'>
          <div className='col-lg-12 col-sm-12'>

            <div className='col-12 d-none d-sm-block text-white bg-secondary'>
              <div className='d-flex'>
                <div className='p-2 col-3'><h6>PROFILE</h6></div>


                <div className='p-2 col-2 text-center'><h6>SUBMISSION</h6></div>

                <div className='p-2 col-2 text-center'><h6>SUBMISSION STATUS</h6></div>
                <div className='p-2 col-2 text-center'><h6>SUBMISSION DATE</h6></div>
                <div className='p-2 col-3 text-end'><h6>ACTION</h6></div>
              </div>
            </div>


            {
              submissions ? submissions.map((item) => (
                <div className='d-flex flex-wrap align-items-center  border-bottom py-2' key={item.id} >
                  <div className='col-3' >
                    <div className="d-flex align-items-center">
                      <div className="avatar-sm">
                        <Avatar src={item.profile_pic} />
                      </div>
                      <div className="ms-2 ">
                        <h6 className="fs-15 mb-0">
                          {item.first_name + " " + item.last_name}

                        </h6>

                        <p className='text-danger' >    {item.email}</p>

                      </div>
                    </div>

                  </div>



                  <div className='p-2 col-lg-2   d-flex justify-content-center align-items-center'>

                    <a className='text-primary text-decoration-none' target='_blank' href={item.submission_url}>Submission</a>

                  </div>
                  <div className='p-2 col-lg-2   d-flex justify-content-center align-items-center'>
                    <Chip
                      label={item.submission_status}
                      color={item.submission_status === "accepted" ? "success" : item.submission_status === "pending" ? "primary" : "warning"}
                    />


                  </div>
                  <div className='col-2 text-center' >
                    <p>{dateFormat(item.submission_date, "dS mmmm yyyy")}</p>
                  </div>

                  <div className='p-2 col-lg-3 text-end '>
                    <Dropdown class="ml-5 d-none">
                      <Dropdown.Toggle variant="light" id="dropdown-basic">
                        <MoreVertIcon />

                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {
                          item.submission_status === "pending" ? (
                            <>
                              <Dropdown.Item className='text-success' onClick={() => updateSubmission({ status: "accepted", id: item.id })} >
                                Accept
                              </Dropdown.Item>
                              <Dropdown.Item className='text-danger' onClick={() => updateSubmission({ status: "rejected", id: item.id })} >
                                Reject
                              </Dropdown.Item></>
                          ) : null}

                        {item.submission_status === "accepted" ? (
                          <>
                            <Dropdown.Item className='text-danger' onClick={() => updateSubmission({ status: "rejected", id: item.id })} >
                              Reject
                            </Dropdown.Item>
                            <Dropdown.Item className='text-warning' onClick={() => updateSubmission({ status: "pending", id: item.id })} >
                              Pending
                            </Dropdown.Item></>
                        ) : null}
                        {item.submission_status === "rejected" ? (
                          <>
                            <Dropdown.Item className='text-success' onClick={() => updateSubmission({ status: "accepted", id: item.id })} >
                              Accept
                            </Dropdown.Item>
                            <Dropdown.Item className='text-warning' onClick={() => updateSubmission({ status: "pending", id: item.id })} >
                              Pending
                            </Dropdown.Item></>
                        ) : null}

                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              )) : null
            }

          </div>
        </div>
      </div>
    </div>
  )
}

export default CompanyBounties
